import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface Coin {
    value: string,
    label: string,
    coinId: string,
    imgUrl: string,
    contentType: string

}
type CoinList = Coin[];
const initialState: CoinList = []
export const coinList = createSlice({
    name: "coinList",
    initialState,
    reducers: {
    
        updateCoinList: (state, action: PayloadAction<[]>) => {
            // console.log('updateCoinWalletStatus', action.payload.status)
            return action.payload
            // state.value = action.payload.value
            // state.label = action.payload.label
            // state.coinId = action.payload.coinId
            // state.imgUrl = action.payload.imgUrl
            // state.contentType = action.payload.contentType

        },
       

    },
});
export const {  updateCoinList} = coinList.actions;

export default coinList.reducer;
